export const webhooksEn = {
  common: {
    createIntegration: `Create Integration`,
    updateIntegration: `Update Integration`,
    failedToSave: `Failed to save`,
    learnMore: `learn more`,
    beta: `Beta`,
  },
  list: {
    failedToLoad: `Failed to load integrations`,
    noIntegrationsAvailable: `No integrations available`,
    integrated: `Integrated`,
    learnMore: `Learn More`,
  },
  detail: {
    status: `Status`,
    on: `On`,
    off: `Off`,
    failedToLoad: `Failed to load integration`,
    back: `← Back`,
    webhooksV2Title: `Webhooks v2.0`,
    xlDentTitle: `Integration for Screen pops`,
    integrationTitle: `Integration for {{name}}`,
    webhooksV2Description: `Event payload will be sent to the Callback URL you provide. You must specify which events to send using the Event Selectors`,
    xlDentDescription: `Know who's calling. Save time. Have the answers quickly. Receive Screen pop notifications on incoming and outbound calls`,
    remoteIdLabel: `Remote ID`,
    practiceGuidLabel: `Practice GUID`,
  },
  dolphin: {
    webhookUrl: `Webhook URL`,
  },
  webhooksV2: {
    remoteId: `Remote ID`,
    remoteIdPlaceholder: `Used to identify the source PBX.`,
    callbackUrl: `Callback URL`,
    callbackUrlPlaceholder: `https://yourdomain.com/mango/event-handler`,
    eventSelectors: `Event Selectors`,
    eventSelectorsLoadError: `Event selectors could not be loaded — refresh to try again.`,
    noEventsWarning: `You haven't chosen any Event Selectors, which will result in no events being sent to that url. Save anyway?`,
    goBack: `Go back`,
    saveAnyway: `Save anyway`,
  },
  xlDent: {
    tableDescription: `Map the Mango Voice Extensions to the Workstation IP Address.`,
    extensionName: `Extension Name`,
    extensionNumber: `Extension #`,
    workstationIp: `Workstation IP Address`,
    enableDisable: `Enable/Disable`,
    disabled: `Disabled.`,
    ipPlaceholder: `e.g. 192.168.1.1:8888`,
    update: `Update`,
    devicesNote: `Note: Any changes will require you to update the Device in 'My Devices' for changes to take affect.`,
  },
  // Copy in this section is intentionally aligned with apidocs.mangovoice.com
  // to ensure partners experience consistent language across both surfaces.
  authKeys: {
    title: `Authorization Keys`,
    description: `Generate a three-part token that authenticates requests to the Mango Voice Global APIs. Share it with your integration partner so they can make API calls on your behalf.`,
    confidential: `Tokens must be kept confidential. Exposing tokens to the public may result in data theft, loss, or corruption.`,
    noKeys: `No authorization keys have been generated yet.`,
    generate: `Generate`,
    regenerate: `Regenerate`,
    remove: `Remove`,
    copy: `Copy`,
    copied: `Copied!`,
    apiDocsLabel: `View API documentation`,
    failedToLoad: `Failed to load authorization keys`,
    failedToGenerate: `Failed to generate authorization keys`,
    failedToRegenerate: `Failed to regenerate authorization keys`,
    failedToRemove: `Failed to remove authorization keys`,
    confirmRegenerateTitle: `Regenerate Authorization Keys`,
    confirmRegenerateBody: `Regenerating authorization keys may disable existing integrations. Are you sure you want to proceed?`,
    confirmRemoveTitle: `Remove Authorization Keys`,
    confirmRemoveBody: `Removing authorization keys may disable existing integrations. Are you sure you want to proceed?`,
    confirmCancel: `Cancel`,
    confirmProceed: `Proceed`,
    combinedToken: `Combined token`,
    combinedTokenHint: `Used as path variables in API requests`,
    formatIdent1: `ident1`,
    formatIdent2: `ident2`,
    formatIdent3: `ident3`,
  },
  admin: {
    apiAccess: {
      title: `API Access`,
      selectPbx: `Select PBX`,
      selectCompanyFirst: `Select a company first`,
      noPbxSelected: `Select a company and PBX above to manage authorization keys.`,
    },
    list: {
      title: `Webhook Integrations`,
      description: `View and manage webhook integration status across all PBXes for a company`,
      companyLabel: `Company`,
      companyPlaceholder: `Select a company…`,
      pbxFilter: `PBX`,
      allPbxes: `All PBXes`,
      integrationFilter: `Integration`,
      allIntegrations: `All Integrations`,
      noCompanySelected: `Select a company to view integrations`,
      noIntegrationsFound: `No integrations found`,
      columnStatus: `Status`,
      columnActive: `Active`,
      notIntegrated: `Not integrated`,
    },
  },
}

export type WebhooksLocale = typeof webhooksEn
